import { Image } from 'react-native';
import { isNil } from 'shared/src/utils';
import type { NearBodyPartType } from '../types';

const IMAGE_HEIGHT = 168;
const IMAGE_WIDTH = 81;

const imageMap = {
  guide1: require('../assets/size_visual_guide_1.png'),
  guide2: require('../assets/size_visual_guide_2.png'),
  guide3: require('../assets/size_visual_guide_3.png'),
  guide4: require('../assets/size_visual_guide_4.png'),
  guide5: require('../assets/size_visual_guide_5.png'),
  guide6: require('../assets/size_visual_guide_6.png'),
  guide7: require('../assets/size_visual_guide_7.png'),
};

interface SizeVisualGuideImageProps {
  nearBodyPart: NearBodyPartType;
  distanceFromBodyPart: number;
}

const getImageSource = (
  nearBodyPart: NearBodyPartType,
  distanceFromBodyPart: number,
) => {
  if (nearBodyPart === 'INSTEP' || nearBodyPart === 'ANKLE') {
    return imageMap.guide1;
  }
  if (nearBodyPart === 'KNEE') {
    return distanceFromBodyPart >= 0 ? imageMap.guide2 : imageMap.guide3;
  }
  if (nearBodyPart === 'HIP') {
    return imageMap.guide4;
  }
  if (nearBodyPart === 'WAIST') {
    if (distanceFromBodyPart > 0) return imageMap.guide5;
    if (distanceFromBodyPart === 0) return imageMap.guide6;
    return imageMap.guide7;
  }
  return null;
};

export const SizeVisualGuideImage = ({
  nearBodyPart,
  distanceFromBodyPart,
}: SizeVisualGuideImageProps) => {
  const source = getImageSource(nearBodyPart, distanceFromBodyPart);
  if (isNil(source)) return null;

  return (
    <Image
      source={source}
      style={{
        height: IMAGE_HEIGHT,
        width: IMAGE_WIDTH,
      }}
      resizeMode="contain"
    />
  );
};
